import CTA from "@/components/ui/CTA";
import { CARD_TEXTURE_SURFACE } from "@/lib/styles/surfaces";

interface WorkCategoryCalloutProps {
  title: string;
  description: string;
  ctaHref: string;
  ctaLabel: string;
  /** Extra classes on the panel (e.g. lighter surface for dense medical disclaimers). */
  className?: string;
}

export default function WorkCategoryCallout({
  title,
  description,
  ctaHref,
  ctaLabel,
  className = "",
}: WorkCategoryCalloutProps) {
  return (
    <section
      className={`py-12 md:py-16 ${CARD_TEXTURE_SURFACE} bg-repeat rounded-3xl px-4 md:px-12 my-12 ${className}`}
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex-1">
          <h2 className="text-3xl font-medium md:text-4xl mb-4">{title}</h2>
          <p className="text-xl text-gray-700 dark:text-zinc-300">
            {description}
          </p>
        </div>
        <div className="flex-shrink-0">
          <CTA href={ctaHref} className="text-lg">
            {ctaLabel}
          </CTA>
        </div>
      </div>
    </section>
  );
}
